import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../store";
import { sendOtp } from "../api/auth";
import { usePostHog } from "posthog-js/react";
import { Modal } from "../modals/Modal";
import { OTPInput } from "../components/OTPInput";
import { Button } from "../ui";
import { useComputeCartAmount } from "../hooks/compute-cart-amount";

export const CartPreview = ({ next }: { next?: string }) => {
	const navigate = useNavigate();
	const posthog = usePostHog();
	const { payableAmount } = useComputeCartAmount();
	const cart = useSelector((state: RootState) => state.cart);
	const accessToken = useSelector(
		(state: RootState) => state.user.accessToken,
	);
	const mobileNumber = useSelector(
		(state: RootState) => state.user.mobileNumber,
	);
	const [showOTPInput, setShowOTPInput] = useState<boolean>(false);

	const handleOnClick = async () => {
		posthog?.capture("[View cart clicked]");

		if (!accessToken) {
			await sendOtp({
				mobileNumber,
			});

			setShowOTPInput(true);
		} else {
			navigate(next || "/repair/repair-slot");
		}
	};

	useEffect(() => {
		if (showOTPInput) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [showOTPInput]);

	if (!cart.cartLinkRepairQuotation.length) return null;

	return (
		<div className="md:rounded-lg flex flex-col md:w-[400px] md:m-auto bg-white z-50 fixed bottom-0 card-shadow-xl p-4 container">
			<div className="flex flex-row items-center justify-between">
				<div className="flex flex-col justify-between">
					<span className="font-medium">
						{cart.cartLinkRepairQuotation[0].cardType}
					</span>
					<span className="font-bold text-lg flex flex-col items-start">
						₹{payableAmount}
					</span>
				</div>
				<div>
					<Button onClick={handleOnClick} className="px-6 pr-10 h-12">
						Proceed
						<span className="bounce arrow prime next" />
						<span className="bounce arrow gen next" />
					</Button>
				</div>
			</div>
			<Modal show={showOTPInput} onClose={() => setShowOTPInput(false)}>
				<div className="rounded-t-xl p-3 bg-white">
					<OTPInput />
				</div>
			</Modal>
		</div>
	);
};

export default CartPreview;
